import { createFileRoute } from '@tanstack/react-router'
import { OverviewPage } from '~/features/compensation/OverviewPage'
import { NoFinanceAccess } from '~/features/compensation/parts'
import { loaderSeason, seasonQuery } from '~/features/compensation/queries'
import { useCan } from '~/lib/session'

export const Route = createFileRoute('/_app/verein/praemien/')({
  loader: async ({ context }) => {
    const s = await loaderSeason(context.queryClient)
    if (s?.canRead) await context.queryClient.ensureQueryData(seasonQuery(s.season))
  },
  component: function Praemien() {
    return useCan()('finance.read') ? <OverviewPage /> : <NoFinanceAccess title="Prämien" />
  },
})
